module.exports = __webpack_public_path__ + "img/statistical-analysis.32b96855.png";